if (!customElements.get("search-form")) {
  class t extends HTMLElement {
    constructor() {
      super(), this.input = this.querySelector(".js-search-input"), this.productTypeSelect = this
        .querySelector(".js-search-product-types"), this.productTypeInput = document
        .getElementById("product_type_input"), this.resetBtn = this.querySelector(
          ".js-search-reset"), this.addListeners(), this.init()
    }
    addListeners() {
      this.input.addEventListener("input", debounce(this.handleInput.bind(this))), this
        .productTypeSelect && this.productTypeSelect.addEventListener("change", this
          .handleProductTypeChange.bind(this)), this.resetBtn.addEventListener("click", this
          .handleReset.bind(this))
    }
    init() {
      (this.input.dataset.placeholderTwo || this.input.dataset.placeholderThree) && ("true" ===
        this.input.dataset.placeholderPromptsMob || theme.mediaMatches.md) && this
        .typeInPlaceholders()
    }
    typeInPlaceholders() {
      let t = this.input.dataset.typingSpeed || 100,
        e = this.input.dataset.deletingSpeed || 60,
        i = this.input.dataset.delayAfterDeleting || 500,
        s = this.input.dataset.delayBeforeFirstDelete || 2e3,
        h = this.input.dataset.delayAfterWordTyped || 2400,
        a = [];
      this.input.placeholder && a.push(this.input.placeholder), this.input.dataset
        .placeholderTwo && a.push(this.input.dataset.placeholderTwo), this.input.dataset
        .placeholderThree && a.push(this.input.dataset.placeholderThree);
      let n = async e => {
        await new Promise(i => {
          let s = this.input.getAttribute("placeholder"),
            h = s.length >= 3 && e.startsWith(s) ? e.replace(s, "") : e,
            a = setInterval(() => {
              s = this.input.getAttribute("placeholder"), this.input.setAttribute(
                "placeholder", s + h.charAt(0)), 1 === h.length ? (i(), clearInterval(
                a)) : h = h.substring(1)
            }, t)
        })
      }, l = async t => {
        await new Promise(i => {
          let s = this.input.getAttribute("placeholder"),
            h = setInterval(() => {
              let e = s.substring(0, s.length - 1);
              this.input.setAttribute("placeholder", e), (0 === (s = e).length || s
                .length >= 3 && t.startsWith(s)) && (i(), clearInterval(h))
            }, e)
        })
      }, d = 0, r = () => {
        d = (d + 1) % a.length;
        let t = a[d];
        l.call(this, t).then(() => {
          setTimeout(() => {
            n.call(this, t).then(() => {
              setTimeout(r.bind(this), h)
            })
          }, i)
        })
      };
      setTimeout(r.bind(this), s)
    }
    handleInput() {
      this.input.value.length > 0 ? this.input.classList.add("search__input--dirty") : this.input
        .classList.remove("search__input--dirty")
    }
    handleProductTypeChange(t) {
      this.productTypeInput.value = t.detail.selectedValue
    }
    handleReset() {
      this.input.classList.remove("search__input--dirty")
    }
  }
  customElements.define("search-form", t)
}
